import React, { useState, useRef } from 'react';

//components
import Icon from '../../../icons/Icon';
import { IconLibrary } from '../../../../../interfaces/icon/IconLibrary';
import { ISimpleTableMenu } from '../../../../../interfaces/tables/ISimpleTable';
import SelectButtonList from '../../../lists/SelectButtonList';

//hooks
import { useClickAwayClose } from '../../../../../hooks/useClickAwayClose';



const SimpleTableMenu = ({ isControlIndex, setControlIndex, buttons } : ISimpleTableMenu) => {
    const [showMenu, setShowMenu] = useState<boolean>(false);
    const ref = useRef<HTMLTableCellElement>(null);

    const handleBlur = (event: React.FocusEvent<HTMLDivElement>) => {
        if (ref.current && !ref.current.contains(event.relatedTarget as Node)) {
          setShowMenu(false);
        }
    };

    useClickAwayClose(showMenu, ref, () => {setShowMenu(false)});

    return (
        <td className="control-cell" ref={ref} onBlur={handleBlur}>
            <button 
                type='button' 
                className="rc-simple-table-menu" 
                aria-label="Open menu" 
                onClick={() => { setControlIndex(); setShowMenu(!showMenu)}}
            >
                <Icon 
                    iconName={IconLibrary.MENU_MORE} 
                    color="#343D4C" 
                    sizeInPx="12" 
                />
            </button>

            {isControlIndex && showMenu && (
                <SelectButtonList 
                    className="simple-controls drag-and-drop-list" 
                    buttons={buttons ?? []} 
                    allButtonOnClick={() => setShowMenu(false)}
                />
            )}
        </td>
    );
};

export default SimpleTableMenu;